import { Component, Input, OnInit } from '@angular/core';
import addDays from 'date-fns/add_days';
import format from 'date-fns/format';

@Component({
  selector: 'ds-premium-details',
  templateUrl: './premium-details.component.html',
  styleUrls: ['./premium-details.component.scss'],
  standalone: false
})
export class PremiumDetailsComponent implements OnInit {
  @Input() quotes: any;
  public quoteExpirationDate: string;

  constructor() {}

  ngOnInit() {
    this.quoteExpirationDate = format(addDays(new Date(), 60), 'MM/DD/YYYY');
  }
}
